import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import OpenPositionsContent from '../components/OpenPositionsContent';

export default function OpenPositions() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="acik-pozisyonlar" />
                    <OpenPositionsContent />
                </div>
            </div>
        </div>
    );
}
